import moment from "moment-timezone";
import { DataTable, type DataTableColumn } from "@/components/ui/DataTable/index";
import { CertificateInstance, useListCertificateInstances } from "@/lib/api/birthdayFundCertificates";
import { GenerateLoadingOrError, CommonDestinationTimezone } from "@/lib/utils";

export function BirthdayFundCertificateList() {
  const certificateInstancesResult = useListCertificateInstances();

  const loadingOrErrorUi = GenerateLoadingOrError([certificateInstancesResult]);
  if (loadingOrErrorUi) return loadingOrErrorUi;

  const instances = certificateInstancesResult?.data?.data?.instances || [];

  const columns: DataTableColumn<CertificateInstance>[] = [
    {
      id: "certificate_id",
      accessorKey: "certificate_id",
      accessorFn: (row: CertificateInstance) => row.certificate_id,
      header: "Certificate ID",
      cell: (info) => info.getValue() as string,
    },
    {
      id: "location_name",
      accessorKey: "location_name",
      accessorFn: (row: CertificateInstance) => row.location_name,
      header: "Location Name",
      cell: (info) => info.getValue() as string,
    },
    {
      id: "created_at",
      accessorKey: "created_at",
      accessorFn: (row: CertificateInstance) => row.created_at,
      header: "Created At",
      cell: (info) => (
        <span className="text-gray-600 text-sm">
          {moment.tz(info.getValue() as string, CommonDestinationTimezone).format("MM/DD/YYYY hh:mm a")}
        </span>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <DataTable
        defaultSorting={[{ id: "created_at", desc: true }]}
        tableClassName="max-h-[680px] overflow-y-scroll"
        columns={columns}
        data={instances}
        className="mx-4"
        enableSorting
        enableMultiSort
        enableFiltering
        enableColumnVisibility
        enableGrouping
        enableExport
        exportFilename={() => ["certificate_list", moment().format("YYYYMMDD")].join("_")}
        stickyHeaders
        filterStyle="select"
        filterMode="internal"
        emptyMessage="No certificates found"
      />
    </div>
  );
}
